import Select from '../../atoms/Select/view';

const BRAZIL_STATES = [
  'AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO',
] as const;

const OPTIONS = BRAZIL_STATES.map((uf) => ({ label: uf, value: uf as string }));

interface PropsStatePicker {
  value?: string | null;
  onChange: (uf: string) => void;
  label?: string;
  placeholder?: string;
}

export default function StatePicker({ value, onChange, label, placeholder = 'Selecione um estado' }: PropsStatePicker) {
  return (
    <Select
      options={OPTIONS}
      value={value ?? undefined}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
    />
  );
}
